import { createSlice } from "@reduxjs/toolkit";

const salesPersonsSlice = createSlice({
  name: "salesPersons",
  initialState: {
    data: [],
    totalRecords: 0,
    isLoading: false,
    error: null,
  },
  reducers: {
    setSalesPersons(state, action) {
      state.data = action.payload.data || [];
      state.totalRecords = action.payload.total || 0;
      state.isLoading = false;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setSalesPersons, setLoading, setError } = salesPersonsSlice.actions;
export default salesPersonsSlice.reducer;
